/**
 * Upload-related constants shared across the entire frontend application
 * Used by both Vue and React components
 */

// Default timeout for uploads (2 minutes)
export const DEFAULT_UPLOAD_TIMEOUT = 2 * 60 * 1000;

// Extended timeout for large file uploads (5 minutes) - matches nginx proxy_read_timeout
export const LARGE_FILE_UPLOAD_TIMEOUT = 5 * 60 * 1000;

// File size constants (in bytes)
export const FILE_SIZE_1MB = 1024 * 1024;
export const FILE_SIZE_10MB = 10 * 1024 * 1024;
export const FILE_SIZE_50MB = 50 * 1024 * 1024;

// Size threshold for large files (50MB) - when to apply extended timeout.
// The default 2-minute timeout covers <50MB at typical connection speeds;
// only genuinely large uploads need the extended 5-minute nginx-aligned window.
export const LARGE_FILE_SIZE_THRESHOLD = FILE_SIZE_50MB;

// AI generation max file size (10MB)
export const AI_GENERATION_MAX_FILE_SIZE = FILE_SIZE_10MB;

// Design tag max file size (50MB)
export const DESIGN_TAG_MAX_FILE_SIZE = FILE_SIZE_50MB;

// Timeout for AI image refinement (5 minutes) - AI processing can be slow
export const AI_REFINE_TIMEOUT = 5 * 60 * 1000;

// Export aliases for backward compatibility
export const DEFAULT_TIMEOUT = DEFAULT_UPLOAD_TIMEOUT;
export const LARGE_FILE_TIMEOUT = LARGE_FILE_UPLOAD_TIMEOUT;
export const LARGE_FILE_THRESHOLD = LARGE_FILE_SIZE_THRESHOLD;

// Picks the upload timeout for a file of the given size in bytes.
// Undefined/missing size falls through to the default 2-minute timeout.
export const getUploadTimeout = size =>
  (size ?? 0) > LARGE_FILE_SIZE_THRESHOLD ? LARGE_FILE_UPLOAD_TIMEOUT : DEFAULT_UPLOAD_TIMEOUT;
